import {
  AloftDate,
  SimilarityScoreWeightsForLocationType,
  calculateSimilarityScore,
} from '@aloft/toolkit-shared';

import { calcSimilarity } from '../internal/similarity/calcSimilarity.ts';
import { CompSelectionProperty } from '../types.ts';
import { toSimilarityScoreCharacteristics } from './toSimilarityScoreCharacteristics.ts';

export type NewSimilarityScoreCalcOptions = {
  weights: SimilarityScoreWeightsForLocationType;
  effectiveDate: AloftDate;
};

export const addSimilarityScores = (
  properties: CompSelectionProperty[],
  subject: CompSelectionProperty,
  newCalcOptions?: NewSimilarityScoreCalcOptions,
) => {
  if (newCalcOptions) {
    const { weights, effectiveDate } = newCalcOptions;
    const subjectChars = toSimilarityScoreCharacteristics(subject, effectiveDate, true);
    const pool = properties.map((p) => toSimilarityScoreCharacteristics(p, effectiveDate));

    properties.forEach((prop) => {
      const compChars = toSimilarityScoreCharacteristics(prop, effectiveDate);
      // eslint-disable-next-line no-param-reassign
      prop.similarityScore = calculateSimilarityScore(weights, subjectChars, compChars, pool);
    });
  } else {
    properties.forEach((prop) => {
      // eslint-disable-next-line no-param-reassign
      prop.similarityScore = calcSimilarity(subject, prop);
    });
  }
};
